import {
  Typography,
  FormControl,
  Container,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  collection,
  updateDoc,
  getDocs,
  getDoc,
  doc,
  query,
  where,
  serverTimestamp,
  addDoc,
} from "firebase/firestore";
import { db } from "../firebase.config";

import { getAuth } from "firebase/auth";
import "../formTopicStyles.css";

function CreateTopic(props) {
  const navigate = useNavigate();
  const auth = getAuth();
  const { appState, setAppState, genres } = props;
  const [formData, setFormData] = useState({
    topicName: "",
    newItem: {
      desc: "",
      imageUrl: "",
    },
    formItems: [],
    formImageSrcs: [],
    showReactCrop: false,
    showReactDrop: true,
  });

  const onChange = (e) => {
    if (e.target.name === "tierListGenre") {
      setAppState((prevState) => ({
        ...prevState,
        tierListGenre: {
          id: e.target.value,
          name: genres[e.target.value].name,
          // name: appState.genres[e.target.value].name,
        },
        tierListTopic: "DEFAULT",
      }));
    }
    if (e.target.name === "desc") {
      setFormData((prevState) => ({
        ...prevState,
        newItem: {
          ...prevState.newItem,
          [e.target.name]: e.target.value,
        },
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const createTopic = async (e) => {
    e.preventDefault();
    if (formData.topicName === "") {
      toast.error("Must include a topic Name! ");
      return;
    }
    if (appState.tierListGenre.name === "DEFAULT") {
      toast.error("Must Choose a genre!");
      return;
    }

    const databaseEntry = {};
    databaseEntry.name = formData.topicName;
    databaseEntry.items = [];
    databaseEntry.timeStamp = serverTimestamp();
    databaseEntry.author = auth.currentUser.uid;

    const newTopicItemsDocRef = await addDoc(
      collection(db, "formItems"),
      databaseEntry
    );

    // Create an entry in the formTopics database.

    /* Slugyify the string */
    // https://gist.github.com/hagemann/382adfc57adbd5af078dc93feef01fe1
    // https://mhagemann.medium.com/the-ultimate-way-to-slugify-a-url-string-in-javascript-b8e4a0d849e1

    function slugify(string) {
      const a =
        "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
      const b =
        "aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
      const p = new RegExp(a.split("").join("|"), "g");

      return (
        string
          .toString()
          .toLowerCase()
          .replace(/\s+/g, "-") // Replace spaces with -
          .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, "-and-") // Replace & with 'and'
          //eslint-disable-next-line
          .replace(/[^\w\-]+/g, "") // Remove all non-word characters
          //eslint-disable-next-line
          .replace(/\-\-+/g, "-") // Replace multiple - with single -
          .replace(/^-+/, "") // Trim - from start of text
          .replace(/-+$/, "")
      ); // Trim - from end of text
    }

    const topicsOptionEntry = {
      itemsRef: newTopicItemsDocRef,
      key: slugify(formData.topicName),
      name: formData.topicName,
    };

    console.log("topicsOptionEntry :", topicsOptionEntry);

    // Get Reference
    const queryString = appState.tierListGenre.id;
    const formTopicsRef = collection(db, "formTopics");
    const genreRef = doc(db, "formGenres", queryString);
    const q = query(formTopicsRef, where("genreRef", "==", genreRef));
    const qSnap = await getDocs(q);
    const formTopicsDocRef = qSnap.docs[0].ref;
    console.log("formTopicsRef :", formTopicsDocRef);
    const formTopicsData = qSnap.docs[0].data();
    const newFormTopicsData = {
      ...formTopicsData,
      options: [...formTopicsData.options, topicsOptionEntry],
      userRef: auth.currentUser.uid,
    };

    // Update listing
    await updateDoc(formTopicsDocRef, newFormTopicsData);
    console.log("newFormTopicsData :", newFormTopicsData);
    console.log("formTopicsData :", formTopicsData);
    console.log("qSnap :", qSnap);

    const genreDoc = await getDoc(genreRef);
    console.log("genreDoc :", genreDoc.data());
    toast.success("New Topic Saved");
    navigate(`/topic/edit/${newTopicItemsDocRef.id}`);

    console.log("topic submitted!");
  };

  return (
    <Container>
      <Typography variant="h1" component="h1">
        Create Topic
      </Typography>
      <p>I see you've choosen the genre {appState.tierListGenre.name}</p>
      <form onSubmit={createTopic}>
        <FormControl
          sx={{
            display: "flex",
            flexDirection: "row",
            margin: "10px 0",
            alignItems: "center",
          }}
        >
          <label htmlFor="tierListGenre">Choose a Genre</label>
          <Select
            labelId="tierListGenre"
            id="tierListGenre"
            name="tierListGenre"
            value={appState.tierListGenre.id}
            label="tierListGenre"
            onChange={onChange}
          >
            {appState.tierListGenre?.name === "DEFAULT" && (
              <MenuItem value="DEFAULT" disabled>
                Genres...
              </MenuItem>
            )}
            {Object.keys(genres).map((genreId) => (
              // genreKey or genreId?
              <MenuItem key={genres[genreId].key} value={genreId}>
                {genres[genreId].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            display: "flex",
            flexDirection: "row",
            margin: "10px 0",
          }}
        >
          <Typography variant="h5" component="h5" sx={{ alignSelf: "center" }}>
            <label htmlFor="tier-list-title">Enter Topic Name: </label>
          </Typography>
          <input
            name="topicName"
            value={formData.topicName}
            id="topicName"
            onChange={onChange}
            aria-describedby="topicName"
            style={{ fontSize: "50px", width: "100%" }}
          />
        </FormControl>

        <Button type="submit" color="success" variant="contained">
          Submit Topic
        </Button>
      </form>
    </Container>
  );
}

export default CreateTopic;
